<script setup lang="ts">
import type { Challenge } from '~/types/challenge'

const authStore = useAuthStore()

const props = defineProps<{
  challenge: Challenge
}>()

const currentUserRank = computed(() => {
  if (!props.challenge) return

  return props.challenge.ranking.find((rank) => rank.user_id === authStore.currentUser?.id)
})

const influencerRanks = computed(() => {
  if (!props.challenge?.influencers_challenge) {
    return null
  }

  return props.challenge.ranking.filter((rank) => {
    return props.challenge?.influencers?.includes(rank.user_id)
  })
})

const currentUserLeadingDirectCompetition = computed(() => {
  if (!props.challenge?.influencers_challenge || !influencerRanks.value) {
    return false
  }

  influencerRanks.value.forEach((influencerRank) => {
    if (!currentUserRank.value || influencerRank.rank < currentUserRank.value.rank) {
      return false
    }
  })

  return true
})

const directCompetitionUserScoreClass = computed(() => {
  return currentUserLeadingDirectCompetition.value ? 'tw-text-riser-green' : 'tw-text-riser-red'
})

const directCompetitionRanks = computed(() => {
  if (
    !props.challenge ||
    !props.challenge.influencers_challenge ||
    !props.challenge.influencers ||
    !influencerRanks.value
  )
    return null

  const ranks = []

  // Add current user rank if the user is not one of the influencers himself
  if (
    currentUserRank.value &&
    !props.challenge.influencers.includes(currentUserRank.value.user_id)
  ) {
    ranks.push(currentUserRank.value)
  }

  influencerRanks.value.forEach((rank) => {
    ranks.push(rank)
  })

  return ranks.sort((a, b) => a.rank - b.rank)
})

const isUserHighlighted = (userId: number) => {
  if (!props.challenge?.influencers_challenge || !props.challenge?.influencers) {
    return false
  }

  return props.challenge.influencers.includes(userId)
}
</script>

<template>
  <div>
    <ChallengeRankingRow
      v-for="rank in directCompetitionRanks"
      :key="rank.user_id"
      :rank="rank"
      :challenge="challenge"
      :highlight-user="isUserHighlighted(rank.user_id)"
      :score-classes="
        rank.user_id === currentUserRank?.user_id ? directCompetitionUserScoreClass : ''
      "
    />
  </div>
</template>
